import { Map as map } from 'immutable';
const C = require("../constants");

function ProductSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.PRODUCT_SELECT:
            return action.data;
        default:
            return state;
    }
}

export default ProductSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProductSelectReducer.js